<template>
	<div class="container page">
		<van-nav-bar :title="this.vod_name" class="nav-bar">
			<template #left>
				<van-icon name="arrow-left" color="#fff" @click="back()" />
			</template>
		</van-nav-bar>
		<div class="right">
			<van-pull-refresh border="false" class="list-wrapper" v-model="isLoading" @refresh="onRefresh">
				<van-grid :column-num="2" :gutter="10">
					<van-grid-item @click="profile(v.id)" v-for="(v, k) in datalist" :key="k">
						<div class="img-box">
							<van-image class="game_item_img" :src="v.img_url" fit="cover">
								<template v-slot:loading>
									<van-loading type="circular" />
								</template>
								<template v-slot:error>
									<div class="img-error">{{ $t('common.image_load_fail') }}</div>
								</template>
							</van-image>
						</div>
						<span class="rig-name">{{ v.xuanfei_name }}</span>
					</van-grid-item>
				</van-grid>
			</van-pull-refresh>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			vod_name: '北京', // 这个值会从路由参数中获取，所以硬编码的中文不会显示
			isLoading: false,
			datalist: [] // 初始为空，数据从API获取
		};
	},
	methods: {
		back() {
			this.$router.push({ path: 'Choose' });
		},
		onRefresh() {
			setTimeout(() => {
				this.$toast(this.$t("reservation.refresh"));
				this.isLoading = false;
			}, 500);
		},
		profile(id) {
			this.$router.push({ path: '/profile?id=' + id + '&name=' + this.vod_name + '&adsid=' + this.$route.query.id });
		},
		getxuanfeilist() {
			this.$http({
				method: 'get',
				url: 'xuanfeilist',
				data: { id: this.$route.query.id }
			}).then(res => {
				this.datalist = res.data;
			});
		}
	},
	created() {
		this.vod_name = this.$route.query.name;
		this.getxuanfeilist();
	}
};
</script>

<style scoped>
.right {
	margin-top: 10px;
}

::v-deep .van-grid-item__content--center {
	border-radius: 15px;
	padding: 0;
	height: auto;
	overflow: hidden;
	background: #fff;
}

.img-box {
	width: 100%;
	height: 320px;
	border-radius: 10px 10px 0 0;
	overflow: hidden;
	background: #f7f7f7;
}

.game_item_img {
	width: 100%;
	height: 100%;
	display: block;
}

::v-deep .game_item_img .van-image__img {
	width: 100%;
	height: 100%;
	object-fit: cover;
	display: block;
}

.img-error {
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 14px;
	color: #999;
	background: #f5f5f5;
}

.rig-name {
	width: 100%;
	height: 60px;
	line-height: 60px;
	background-color: #f7f7f7;
	font-size: 15px;
	padding: 0 10px;
	box-sizing: border-box;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
	border-radius: 0 0 15px 15px;
}
</style>